import { Link } from "react-router-dom";
import { TabBar } from "../components/TabBar";
import { useAuth } from "../contexts/AuthContext";

const VAULTS = ["main", "health", "finance", "work", "family"] as const;

export default function Settings() {
  const { unlocked, expiresAt, lock } = useAuth();
  const minutesLeft = expiresAt ? Math.max(0, Math.round((expiresAt - Date.now()) / 60000)) : 0;

  return (
    <div className="min-h-screen pb-20 px-4 pt-3">
      <h1 className="text-attic-accent font-bold text-base mb-3">attic</h1>
      <h2 className="text-lg font-bold mb-4">Settings</h2>

      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mb-2">Session</p>
      <div className="bg-attic-surface border border-attic-border rounded-xl mb-4">
        <div className="flex items-center justify-between p-3 border-b border-attic-border">
          <span className="text-sm">Sensitive vaults</span>
          <span className={`text-[10px] font-bold rounded-full px-2 py-0.5 ${unlocked ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>
            {unlocked ? `Unlocked · ${minutesLeft} min left` : "Locked"}
          </span>
        </div>
        <button onClick={lock} className="w-full text-left p-3 text-attic-accent text-sm">Lock now</button>
      </div>

      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mb-2">Security</p>
      <div className="bg-attic-surface border border-attic-border rounded-xl mb-4">
        <Link to="/settings/passcode" className="flex justify-between p-3 text-sm">
          <span>Change passcode</span><span className="text-attic-dim">›</span>
        </Link>
        <div className="p-3 flex justify-between border-t border-attic-border">
          <span className="text-sm">Auto-lock</span>
          <span className="text-attic-dim text-xs">After 30 min idle</span>
        </div>
      </div>

      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mb-2">Suggested questions</p>
      <div className="bg-attic-surface border border-attic-border rounded-xl mb-4">
        {VAULTS.map((v, i) => (
          <Link
            key={v}
            to={`/settings/suggestions/${v}`}
            className={`flex justify-between p-3 text-sm ${i < VAULTS.length - 1 ? "border-b border-attic-border" : ""}`}
          >
            <span>Edit {v[0].toUpperCase() + v.slice(1)} suggestions</span>
            <span className="text-attic-dim">›</span>
          </Link>
        ))}
      </div>

      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mb-2">Tag cleanup</p>
      <div className="bg-attic-surface border border-attic-border rounded-xl mb-4">
        <div className="flex justify-between p-3 text-sm">
          <span>Possible tag merges</span>
          <span className="text-attic-dim text-xs">0 pending</span>
        </div>
      </div>

      <p className="text-[10px] uppercase font-bold text-attic-dim tracking-wider mb-2">About</p>
      <div className="bg-attic-surface border border-attic-border rounded-xl mb-4">
        <div className="p-3 flex justify-between text-sm border-b border-attic-border">
          <span>Version</span><span className="text-attic-dim">phase-5</span>
        </div>
        <div className="p-3 flex justify-between text-sm">
          <span>Vault domain</span><span className="text-attic-dim">attic-hq.com</span>
        </div>
      </div>

      <TabBar />
    </div>
  );
}
